import React from 'react';

import { IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { ellipsisHorizontal, statsChart } from 'ionicons/icons';

import Button from 'components/Button';
import EmptyContent from 'components/EmptyContent';
import ProgressBar from 'components/ProgressBar';

const ChartEmpty = ({
  isRefetching,
  onShowMetricsModal,
}: {
  isRefetching: boolean;
  onShowMetricsModal: () => void;
}) => {
  return (
    <IonGrid>
      <IonRow>
        <IonCol>
          <div className={'chips'}>
            <Button fill={'clear'} onClick={onShowMetricsModal}>
              <IonIcon icon={ellipsisHorizontal} />
            </Button>
          </div>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol className={'ion-padding'}>
          <EmptyContent icon={statsChart}>
            {isRefetching && <ProgressBar type={'indeterminate'} />}
          </EmptyContent>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
export default ChartEmpty;
